
export default function ProductsCategories() {
  const categories = [
    {
      icon: 'ri-camera-line',
      title: 'Vidéosurveillance',
      description: 'Caméras de sécurité professionnelles avec technologie avancée',
      color: 'bg-blue-500',
      image: 'https://public.readdy.ai/ai/img_res/0b04fe04244e95e4204486b630d48ca1.jpg'
    },
    {
      icon: 'ri-fire-line',
      title: 'Détection Incendie',
      description: 'Détecteurs de fumée et systèmes d\'alarme incendie professionnels',
      color: 'bg-red-500',
      image: 'https://readdy.ai/api/search-image?query=Fire%20detection%20equipment%20display%20in%20security%20store%2C%20smoke%20detectors%20and%20fire%20alarm%20systems%20on%20shelves%2C%20professional%20fire%20safety%20products%2C%20modern%20fire%20detection%20technology%2C%20safety%20equipment%20showroom&width=400&height=250&seq=fire-detection-products&orientation=landscape'
    },
    {
      icon: 'ri-drop-line',
      title: 'Extinction Automatique',
      description: 'Systèmes d\'extinction automatique avec agents gazeux spécialisés',
      color: 'bg-green-500',
      image: 'https://readdy.ai/api/search-image?query=Automatic%20fire%20suppression%20systems%20display%20in%20professional%20store%2C%20gas%20cylinders%20NOVEC%20FM200%20CO2%20equipment%2C%20fire%20suppression%20products%20on%20shelves%2C%20industrial%20safety%20equipment%20showroom%2C%20professional%20fire%20protection%20technology&width=400&height=250&seq=suppression-products&orientation=landscape'
    },
    {
      icon: 'ri-key-line',
      title: 'Contrôle d\'Accès',
      description: 'Solutions de contrôle d\'accès avec badges RFID et biométrie',
      color: 'bg-purple-500',
      image: 'https://readdy.ai/api/search-image?query=Access%20control%20systems%20display%20in%20security%20store%2C%20electronic%20keypads%20card%20readers%20biometric%20scanners%20on%20shelves%2C%20modern%20access%20control%20products%2C%20professional%20security%20equipment%20showroom%2C%20electronic%20access%20technology&width=400&height=250&seq=access-control-products&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Anti-Intrusion',
      description: 'Détecteurs de mouvement et systèmes d\'alarme anti-intrusion',
      color: 'bg-orange-500',
      image: 'https://readdy.ai/api/search-image?query=Intrusion%20detection%20systems%20display%20in%20security%20store%2C%20motion%20detectors%20alarm%20sensors%20on%20shelves%2C%20professional%20anti-intrusion%20products%2C%20modern%20security%20equipment%20showroom%2C%20alarm%20system%20technology&width=400&height=250&seq=intrusion-products&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos <span className="text-red-600">Catégories</span> de Produits
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez notre gamme complète d'équipements de sécurité professionnels
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category) => (
            <div key={category.title} className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer border border-gray-100">
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <div className={`${category.color} w-12 h-12 rounded-full flex items-center justify-center shadow-lg`}>
                    <i className={`${category.icon} text-xl text-white`}></i>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8 text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                  {category.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {category.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
